import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthStoreState {
  accessToken: string | null;
  setAccessToken: (value: string | null) => void;
  isLoggedIn: boolean;
  setIsLoggedIn: (value: boolean) => void;
  isUserVerified: boolean;
  setIsUserVerified: (value: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create(
  persist<AuthStoreState>(
    set => ({
      isLoggedIn: false,
      setIsLoggedIn: isLoggedIn => set({ isLoggedIn }),
      isUserVerified: false,
      setIsUserVerified: isUserVerified => set({ isUserVerified }),
      accessToken: null,
      setAccessToken: accessToken => set({ accessToken }),
      logout: () => set({ accessToken: null, isLoggedIn: false }),
    }),
    {
      name: 'virtual-evse-auth-data',
      partialize: state => ({ accessToken: state.accessToken }) as AuthStoreState,
    },
  ),
);
